// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-09-07T08:17:31.486Z",
  gitInfo: {
    dirty: false,
    raw: "839803395",
    hash: "839803395",
    distance: null,
    tag: null,
    semver: null,
    suffix: "839803395",
    semverString: null
  }
};
/* tslint:enable */
